<template>
  <div class="inquire" v-cloak>
    <div class="sdw-bg">
      <app-header></app-header>
      <div class="sdw-banner">
        <div class="sdw-title-box">
          <p class="sdw-title">{{ $t('xdata.Nav_lxwm') }}</p>
          <p class="sdw-sub animated flipInX">{{ $t('xdata.About_bt') }}</p>
        </div>
      </div>
    </div>
    <div class="sdw-content">
      <div class="sdw-content-box">
        <div class="sdw-item animated fadeInUp" style="padding-top: 40px;">
          <img src="@/assets/img/about/map1.png">
          <div>
            <p class="carousel-title">{{ $t('xdata.About_xyl') }}</p>
            <p class="carousel-sub">Address: 1052 Budapest Apáczai Csere János street 5, I/2 Hungary</p>
            <p class="carousel-sub">Phone：+36 30 132 9988</p>
            <p class="carousel-sub">Fax： +36 30 132 9988</p>
            <p class="carousel-sub">E-mail: simon.song@xdataglobal.com</p>
          </div>
        </div>
        <div class="sdw-item animated fadeInUp" style="padding-top: 40px;">
          <div>
            <p class="carousel-title">{{ $t('xdata.About_sh') }}</p>
            <p class="carousel-sub">Address: {{ $t('xdata.About_shd') }}</p>
            <p class="carousel-sub">Phone：+86-021-61103898</p>
            <p class="carousel-sub">Fax：+86-021-54241560</p>
            <p class="carousel-sub">E-Mail：info@xdataglobal.com</p>
          </div>
          <img src="@/assets/img/about/map0.png">
        </div>
        <div class="sdw-item animated fadeInUp" style="padding-top: 40px;">
          <img src="@/assets/img/about/map5.png">
          <div>
            <p class="carousel-title">{{ $t('xdata.About_hk') }}</p>
            <p class="carousel-sub">Address: Unit13 22F Seapower Tower Concordia Plaza No.1 Science Museum Road Kowloon Hong Kong （ CHINA AEROSPACE TOWER ）</p>
            <p class="carousel-sub">Phone： +00852-92795511</p>
            <p class="carousel-sub">Fax： +00852-92795511</p>
            <p class="carousel-sub">E-mail： joyce.chen@xdataglobal.com</p>
          </div>
        </div>
        <div class="sdw-item animated fadeInUp" style="padding-top: 40px;">
          <div>
            <p class="carousel-title">{{ $t('xdata.About_us') }}</p>
            <p class="carousel-sub">Address: 20381 Lake Forest Drive, Unit B-16, Lake Forest, CA 92630 US</p>
            <p class="carousel-sub">Phone：+1（949）328-9101</p>
            <p class="carousel-sub">Phone：+1（909）413-9933</p>
            <p class="carousel-sub">E-Mail：jasmine.w@xdataglobal.com</p>
          </div>
          <img src="@/assets/img/about/map2.png">
        </div>
        <div class="sdw-item animated fadeInUp" style="padding-top: 40px;">
          <img src="@/assets/img/about/map3.png">
          <div>
            <p class="carousel-title">{{ $t('xdata.About_de') }}</p>
            <p class="carousel-sub">Address: Neersener Str. 4 40547, Düsseldorf, Germany</p>
            <p class="carousel-sub">Phone：+49-162-2494618</p>
            <p class="carousel-sub">Email：peter.xue@xdataglobal.com</p>
          </div>
        </div>
        <div class="sdw-item animated fadeInUp" style="padding-top: 40px;">
          <div>
            <p class="carousel-title">{{ $t('xdata.About_sp') }}</p>
            <p class="carousel-sub">Address: Calle de La Bañeza 40, 8，puerta 3，28029，MADRID</p>
            <p class="carousel-sub">Phone：+34 657890321</p> 
            <p class="carousel-sub">Email：bill.guo@xdataglobal.com</p> 
          </div>
          <img src="@/assets/img/about/map4.png">
        </div>
      </div>
    </div>
    <app-footer></app-footer>
  </div>
</template>

<script>

import Header from "@/components/header";
import Footer from "@/components/footer";
import DataItem from "@/components/dataItem";
import SolItem from "@/components/solItem";

export default {
  components: {
    "app-header": Header,
    "app-footer": Footer,
    "data-item": DataItem,
    "sol-item": SolItem,
  },
  name: "service",
  data() {
    return {
    };
  },
  mounted() {
  },
  methods: {

  }
};
</script>
<style scoped>
.sdw-bg {
  width: 100%;
  background: url('../assets/img/about.jpg') no-repeat fixed top center / 100% auto;
}

.sdw-banner {
  height: 240px;
  background: rgba(0, 0, 0, 0.3);
}

.sdw-title-box {
  padding-top: 60px;
  width: 1200px;
  margin: 0 auto;
}

.sdw-title {
  font-size: 32px;
  color: #fff;
  margin-bottom: 20px;
  text-align: center;
}
.sdw-sub{
  text-align: center;
  color: #fff;
}

.sdw-content {
  background: #f4f4f4;
}

.sdw-content-box {
  width: 1200px;
  margin: 0 auto;
}

.sdw-content-title {
  font-size: 28px;
  text-align: center;
  padding: 50px 0 0;
}

.sdw-content-text {
  color: #fff;
}

.sdw-content-list {
  padding-top: 50px;
}

.sdw-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px dashed #dcdcdc;
  padding: 60px 0px 30px;
}
.sdw-item:last-child {
  border: none;
}

.sdw-item img {
  display: block;
  width: 380px;
}

.sdw-item div {
  display: flex;
  flex-direction: column;
  width: 600px;
}

.carousel-title {
  font-size: 34px;
  color: #000;
  margin-bottom: 10px;
}

.line {
  width: 50px;
  height: 1px;
  border-bottom: 2px solid #009DE4;
  margin-bottom: 20px;
}
.carousel-sub{
  color: #333;
  margin-bottom: 6px;
}
</style>


// WEBPACK FOOTER //
// src/views/about.vue